export enum FroalaCommand {
    ALIGN = 'align',
    BACKGROUND_COLOR = 'backgroundColor',
    BOLD = 'bold',
    CLEAR_FORMATTING = 'clearFormatting',
    FONT_FAMILY = 'fontFamily',
    FONT_SIZE = 'fontSize',
    FORMAT_OL = 'formatOL',
    FORMAT_UL = 'formatUL',
    FULLSCREEN = 'fullscreen',
    HTML = 'html',
    IMAGE_ALIGN = 'imageAlign',
    IMAGE_DISPLAY = 'imageDisplay',
    IMAGE_SET_ALT = 'imageSetAlt',
    IMAGE_SET_SIZE = 'imageSetSize',
    IMAGE_STYLE = 'imageStyle',
    INDENT = 'indent',
    INLINE_STYLE = 'inlineStyle',
    INSERT_HR = 'insertHR',
    ITALIC = 'italic',
    LINK_INSERT = 'linkInsert',
    LINK_LIST = 'linkList',
    LINK_OPEN = 'linkOpen',
    LINK_REMOVE = 'linkRemove',
    LINK_STYLE = 'linkStyle',
    OUTDENT = 'outdent',
    PARAGRAPH_FORMAT = 'paragraphFormat',
    PARAGRAPH_STYLE = 'paragraphStyle',
    QUOTE = 'quote',
    REDO = 'redo',
    SELECT_ALL = 'selectAll',
    STRIKE_THROUGH = 'strikeThrough',
    SUBSCRIPT = 'subscript',
    SUPERSCRIPT = 'superscript',
    TABLE_CELL_BACKGROUND_COLOR = 'tableCellBackgroundColor',
    TABLE_CELL_STYLE = 'tableCellStyle',
    TABLE_CELLS = 'tableCells',
    TABLE_COLUMNS = 'tableColumns',
    TABLE_HEADER = 'tableHeader',
    TABLE_INSERT = 'tableInsert',
    TABLE_REMOVE = 'tableRemove',
    TABLE_ROWS = 'tableRows',
    TABLE_CELL_VERTICAL_ALIGN = 'tableCellVerticalAlign',
    TABLE_CELL_HORIZONTAL_ALIGN = 'tableCellHorizontalAlign',
    TEXT_COLOR = 'textColor',
    UNDERLINE = 'underline',
    UNDO = 'undo',
    UPDATE_TEXT = 'updateText',
    VIDEO_ALIGN = 'videoALign',
    VIDEO_DISPLAY = 'videoDisplay',
    VIDEO_INSERT_EMBED = 'videoInsertEmbed',
    VIDEO_INSERT_BY_URL = 'videoInsertByURL',
    VIDEO_REMOVE = 'videoRemove',
    VIDEO_SET_SIZE = 'videoSetSize',
}
